// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/ontology/api/project.proto (package gx.ontology.api, syntax proto3)
/* eslint-disable */

import { ProjectService } from "./project_pb.js";

/**
 * @generated from rpc gx.ontology.api.ProjectService.GetProject
 */
export const getProject = ProjectService.method.getProject;

/**
 * @generated from rpc gx.ontology.api.ProjectService.ListProjects
 */
export const listProjects = ProjectService.method.listProjects;

/**
 * @generated from rpc gx.ontology.api.ProjectService.ListProjectsCount
 */
export const listProjectsCount = ProjectService.method.listProjectsCount;

/**
 * @generated from rpc gx.ontology.api.ProjectService.CreateProject
 */
export const createProject = ProjectService.method.createProject;

/**
 * @generated from rpc gx.ontology.api.ProjectService.CreateProjectSources
 */
export const createProjectSources = ProjectService.method.createProjectSources;

/**
 * @generated from rpc gx.ontology.api.ProjectService.UpdateProject
 */
export const updateProject = ProjectService.method.updateProject;

/**
 * @generated from rpc gx.ontology.api.ProjectService.DeleteProject
 */
export const deleteProject = ProjectService.method.deleteProject;

/**
 * @generated from rpc gx.ontology.api.ProjectService.DeleteProjectSource
 */
export const deleteProjectSource = ProjectService.method.deleteProjectSource;
